export const CREATE_CONTENT = "content/create";
export const UPLOAD_FILE = "content/fileupload";
export const ADD_TEXT = "/content/addtext";
export const ADD_FILE = "/content/addfile";
export const ADD_AV = "/content/addav";
export const ADD_CONTENT = "/content/crate_content";
